/**
 * Get menu permissions from localStorage
 * @param {string} menu
 * @param {string} path
 * @returns {Object}
 */

export const getMenuPermissions = (menu, path) => {
  const accessPermission = localStorage.getItem('accessPermission');
  const menus = accessPermission ? JSON.parse(accessPermission) : {};
  const menuPermission = menus[menu]?.find(menu => menu.path === path);
  return menuPermission?.permission || {};
};
